import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import betrvnw from "../../../components/tables/betr-vnw";

const data = [
  {
    les: "24",
    table: betrvnw
  }
];

export default () => (
  <TableSelector
    defaultChapter="24"
    data={data}
    title="Betrekkelijk voornaamwoord"
  />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/betrekkelijk-voornaamwoord.js